import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById('root'));

//TODO: replace above code with code below (code below uses the new architecture but has issue with some click events in web)
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/pingPong-sw.js')
      .then((reg) => console.debug('PingPong Service Worker registered:', reg))
      .catch((err) => console.error('PingPong Service Worker failed:', err));
  });
}
